import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-900 text-background-100" role="contentinfo">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold text-background-50 font-heading">
                17c一起草在线
              </span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">
              {t("siteDescription")} — 海量高清视频资源，电影、电视剧、综艺、动漫、纪录片应有尽有。无需下载，即点即播，随时随地畅享精彩内容。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              {t("allCategories")}
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              快捷链接
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">
                  {t("home")}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">
                  {t("about")}
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow">
                  {t("privacyPolicy")}
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow">
                  {t("termsOfService")}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              {t("followUs")}
            </h4>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="B站" rel="nofollow">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="抖音" rel="nofollow">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            {t("copyright")}
          </p>
          <p className="text-xs text-background-500">
            本站内容仅供学习交流，请支持正版
          </p>
        </div>
      </div>
    </footer>
  );
}